export var Dx7Sysex;
(function (Dx7Sysex) {
    Dx7Sysex.PATCH_SIZE = 155;
    Dx7Sysex.PACKED_SIZE = 128;
    Dx7Sysex.BANK_SIZE = 4104;
    Dx7Sysex.BANK_BODY = 4096;
    Dx7Sysex.VOICE_SIZE = 163;
    Dx7Sysex.NAME_OFFSET = 145;
    Dx7Sysex.NAME_LENGTH = 10;
    Dx7Sysex.checksum = (bytes) => {
        let sum = 0;
        for (const byte of bytes) {
            sum -= byte;
        }
        return sum & 0x7F;
    };
    Dx7Sysex.unpack = (bulk) => {
        const patch = new Uint8Array(Dx7Sysex.PATCH_SIZE);
        for (let op = 0; op < 6; op++) {
            const src = op * 17;
            const dst = op * 21;
            for (let index = 0; index < 11; index++) {
                patch[dst + index] = bulk[src + index] & 0x7F;
            }
            const leftRightCurves = bulk[src + 11] & 0xF;
            patch[dst + 11] = leftRightCurves & 3;
            patch[dst + 12] = (leftRightCurves >> 2) & 3;
            const detuneRateScaling = bulk[src + 12] & 0x7F;
            patch[dst + 13] = detuneRateScaling & 7;
            const velocityAmpMod = bulk[src + 13] & 0x1F;
            patch[dst + 14] = velocityAmpMod & 3;
            patch[dst + 15] = (velocityAmpMod >> 2) & 7;
            patch[dst + 16] = bulk[src + 14] & 0x7F;
            const coarseMode = bulk[src + 15] & 0x3F;
            patch[dst + 17] = coarseMode & 1;
            patch[dst + 18] = (coarseMode >> 1) & 0x1F;
            patch[dst + 19] = bulk[src + 16] & 0x7F;
            patch[dst + 20] = (detuneRateScaling >> 3) & 0x7F;
        }
        for (let index = 0; index < 8; index++) {
            patch[126 + index] = bulk[102 + index] & 0x7F;
        }
        patch[134] = bulk[110] & 0x1F;
        const syncFeedback = bulk[111] & 0xF;
        patch[135] = syncFeedback & 7;
        patch[136] = syncFeedback >> 3;
        patch[137] = bulk[112] & 0x7F;
        patch[138] = bulk[113] & 0x7F;
        patch[139] = bulk[114] & 0x7F;
        patch[140] = bulk[115] & 0x7F;
        const sensWaveSync = bulk[116] & 0x7F;
        patch[141] = sensWaveSync & 1;
        patch[142] = (sensWaveSync >> 1) & 7;
        patch[143] = sensWaveSync >> 4;
        patch[144] = bulk[117] & 0x7F;
        for (let index = 0; index < Dx7Sysex.NAME_LENGTH; index++) {
            patch[Dx7Sysex.NAME_OFFSET + index] = bulk[118 + index] & 0x7F;
        }
        return patch;
    };
    Dx7Sysex.pack = (patch) => {
        const bulk = new Uint8Array(Dx7Sysex.PACKED_SIZE);
        for (let op = 0; op < 6; op++) {
            const src = op * 21;
            const dst = op * 17;
            bulk.set(patch.subarray(src, src + 11), dst);
            bulk[dst + 11] = ((patch[src + 12] & 3) << 2) | (patch[src + 11] & 3);
            bulk[dst + 12] = ((patch[src + 20] & 0x0F) << 3) | (patch[src + 13] & 7);
            bulk[dst + 13] = ((patch[src + 15] & 7) << 2) | (patch[src + 14] & 3);
            bulk[dst + 14] = patch[src + 16];
            bulk[dst + 15] = ((patch[src + 18] & 0x1F) << 1) | (patch[src + 17] & 1);
            bulk[dst + 16] = patch[src + 19];
        }
        bulk.set(patch.subarray(126, 134), 102);
        bulk[110] = patch[134] & 0x1F;
        bulk[111] = ((patch[136] & 1) << 3) | (patch[135] & 7);
        bulk.set(patch.subarray(137, 141), 112);
        bulk[116] = ((patch[143] & 7) << 4) | ((patch[142] & 7) << 1) | (patch[141] & 1);
        bulk[117] = patch[144];
        bulk.set(patch.subarray(Dx7Sysex.NAME_OFFSET, Dx7Sysex.NAME_OFFSET + Dx7Sysex.NAME_LENGTH), 118);
        return bulk;
    };
    Dx7Sysex.voiceName = (patch) => Array.from(patch.subarray(Dx7Sysex.NAME_OFFSET, Dx7Sysex.NAME_OFFSET + Dx7Sysex.NAME_LENGTH))
        .map(code => code >= 32 && code < 127 ? String.fromCharCode(code) : " ")
        .join("").trim();
    Dx7Sysex.withName = (patch, name) => {
        const copy = new Uint8Array(patch);
        for (let index = 0; index < Dx7Sysex.NAME_LENGTH; index++) {
            const code = name.charCodeAt(index);
            copy[Dx7Sysex.NAME_OFFSET + index] = Number.isNaN(code) ? 32 : code >= 32 && code < 127 ? code : 32;
        }
        return copy;
    };
    const isBankHeader = (bytes) => bytes[0] === 0xF0 && bytes[1] === 0x43 && (bytes[2] & 0xF0) === 0 && bytes[3] === 0x09 && bytes[4] === 0x20 && bytes[5] === 0x00;
    const isVoiceHeader = (bytes) => bytes[0] === 0xF0 && bytes[1] === 0x43 && (bytes[2] & 0xF0) === 0 && bytes[3] === 0x00 && bytes[4] === 0x01 && bytes[5] === 0x1B;
    const toVoice = (data) => ({ name: Dx7Sysex.voiceName(data), data });
    const decodeBankBody = (body) => Array.from({ length: 32 }, (_, index) => toVoice(Dx7Sysex.unpack(body.subarray(index * Dx7Sysex.PACKED_SIZE, (index + 1) * Dx7Sysex.PACKED_SIZE))));
    // One sysex message (F0..F7): a bank dump or a single voice dump. Throws on anything else.
    const decodeMessage = (message) => {
        if (message.length === Dx7Sysex.BANK_SIZE && isBankHeader(message)) {
            const body = message.subarray(6, 6 + Dx7Sysex.BANK_BODY);
            if (Dx7Sysex.checksum(body) !== message[6 + Dx7Sysex.BANK_BODY]) {
                throw new Error("bank checksum mismatch");
            }
            return decodeBankBody(body);
        }
        if (message.length === Dx7Sysex.VOICE_SIZE && isVoiceHeader(message)) {
            const data = message.slice(6, 6 + Dx7Sysex.PATCH_SIZE);
            if (Dx7Sysex.checksum(data) !== message[6 + Dx7Sysex.PATCH_SIZE]) {
                throw new Error("voice checksum mismatch");
            }
            return [toVoice(data)];
        }
        throw new Error(`not a DX7 dump (${message.length} bytes)`);
    };
    // Every voice in a .syx file: a headerless 4096-byte cartridge, or one or more sysex messages.
    Dx7Sysex.decode = (bytes) => {
        if (bytes.length === Dx7Sysex.BANK_BODY && bytes[0] !== 0xF0) {
            return decodeBankBody(bytes);
        }
        const voices = [];
        let cursor = 0;
        while (cursor < bytes.length) {
            const start = bytes.indexOf(0xF0, cursor);
            if (start < 0) {
                break;
            }
            const end = bytes.indexOf(0xF7, start);
            if (end < 0) {
                throw new Error("unterminated sysex message");
            }
            voices.push(...decodeMessage(bytes.subarray(start, end + 1)));
            cursor = end + 1;
        }
        if (voices.length === 0) {
            throw new Error("no DX7 voices found");
        }
        return voices;
    };
    Dx7Sysex.encodeBank = (voices) => {
        if (voices.length !== 32) {
            throw new Error("a cartridge holds 32 voices");
        }
        const bank = new Uint8Array(Dx7Sysex.BANK_SIZE);
        bank.set([0xF0, 0x43, 0x00, 0x09, 0x20, 0x00], 0);
        voices.forEach((voice, index) => bank.set(Dx7Sysex.pack(voice), 6 + index * Dx7Sysex.PACKED_SIZE));
        bank[6 + Dx7Sysex.BANK_BODY] = Dx7Sysex.checksum(bank.subarray(6, 6 + Dx7Sysex.BANK_BODY));
        bank[Dx7Sysex.BANK_SIZE - 1] = 0xF7;
        return bank;
    };
    Dx7Sysex.encodeVoice = (patch) => {
        const message = new Uint8Array(Dx7Sysex.VOICE_SIZE);
        message.set([0xF0, 0x43, 0x00, 0x00, 0x01, 0x1B], 0);
        message.set(patch.subarray(0, Dx7Sysex.PATCH_SIZE), 6);
        message[6 + Dx7Sysex.PATCH_SIZE] = Dx7Sysex.checksum(patch.subarray(0, Dx7Sysex.PATCH_SIZE));
        message[Dx7Sysex.VOICE_SIZE - 1] = 0xF7;
        return message;
    };
})(Dx7Sysex || (Dx7Sysex = {}));
